(() => {
  const key = 'sg_reduce_effects';
  const root = document.documentElement;
  const media = window.matchMedia('(prefers-reduced-motion: reduce)');
  let chosen = false;
  try { chosen = localStorage.getItem(key) === 'true'; } catch (_) {}
  function sync() {
    const reduced = chosen || media.matches;
    root.toggleAttribute('data-reduce-effects', reduced);
    document.querySelectorAll('.sg-effects-control').forEach((control) => {
      const input = control.querySelector('input');
      input.checked = reduced;
      input.setAttribute('aria-disabled', String(media.matches));
      control.querySelector('.sg-effects-status').textContent = media.matches
        ? control.dataset.device : reduced ? control.dataset.off : control.dataset.on;
    });
  }
  function init() {
    document.querySelectorAll('.sg-effects-control').forEach((control) => {
      const input = control.querySelector('input');
      if (input.dataset.bound) return;
      input.dataset.bound = 'true';
      input.addEventListener('change', () => {
        if (media.matches) { sync(); return; }
        chosen = input.checked;
        try { localStorage.setItem(key, String(chosen)); } catch (_) {}
        sync();
      });
      control.hidden = false;
    });
    sync();
  }
  sync();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
  media.addEventListener('change', sync);
  window.addEventListener('storage', (event) => {
    if (event.key === key || event.key === null) {
      chosen = event.key === key && event.newValue === 'true';
      sync();
    }
  });
})();
